






















	import Products from '../components/ShopInventoryProductsTable.vue'
	import Inventories from '../components/ShopInventoryAcardion.vue'
	import Component, { mixins } from 'vue-class-component'
	import {
		Instance
	} from '@/classes/TayehApi';
import { GetInventoryResponse } from '@/classes/TayehApi/Instance';
import {IsCollapseMixin, ThemeMixin} from '@/mixins/UI';
import { Inject } from 'vue-property-decorator';

	// import Create from '../../components/product/Create'

	@Component({
		components: {
			'products': Products,
			'inventories': Inventories
		}
	})
	export default class ShopInventoryDashboardProducts extends mixins(IsCollapseMixin, ThemeMixin) {
		@Inject('getInstance') getInstance: any;
		private inventories: GetInventoryResponse[] = null;
		private show_aside = false;
		get asideWidth() {
			// return '20%'
			if (this.window_width > 1200) return '20%';
			return this.show_aside ? '300px' : '0'
		}
		get showAsideToggle() {
			return this.window_width <= 1200;
		}
		update() {
			(this.$refs.list as any).getProducts();
		}

		async getInventories() {
			try {
				const res = await Instance.getInventories(this.getInstance().id);
				this.inventories = res.data;
			} catch (err) {
				console.error(err);
			}
		}

		async createInventory() {
			try {
				// const res =
				await Instance.createInventory(this.getInstance().id, {
					name: 'انبار اصلی'
				})
			} catch (err) {
				console.error(err);
			}
		}

		mounted() {			
			this.getInventories();
		}
	}
